<button
  [ngStyle]="style"
  [ngClass]="{
    'sm-button-padding': sm,
    'icon-only': (icon && !label) || icon,
    'sm-icon-only': icon && !label && sm,
    isLoading: isLoading
  }"
  [type]="type"
  [class]="icon && !label ? class : 'btn ' + class"
  (click)="onButtonClick($event)"
  (submit)="onButtonClick($event)"
  [disabled]="disabled"
>
  <div
    *ngIf="!isLoading"
    class="button-content"
    [ngClass]="{
    'icon-right': iconPos === 'right',
    'icon-left': iconPos !== 'right',
    'text-left': textPos === 'left',
    'text-center': textPos === 'center',
    'text-right': textPos === 'right',
    'sm': sm
  }"
  >
    <i *ngIf="icon" class="material-icons">{{ icon }}</i>
    <span *ngIf="label">{{ label }}</span>
  </div>
  <ng-content></ng-content>
  <hf-custom-spinner *ngIf="isLoading" [darkTheme]="darkTheme" [saveButton]="true"></hf-custom-spinner>
</button>
